import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { LoaderService } from './shared/services/loader.service';
import { Keepalive } from '@ng-idle/keepalive';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { filter } from 'rxjs';

export const browserRefresh = false;


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit{
  dialogRef: MatDialogRef<any>;
  @ViewChild('sessionDialog', {static: true}) sessionDialog = {} as TemplateRef<any>;
  constructor(private readonly authService: AuthService,
    private readonly loaderService: LoaderService, 
    private readonly router: Router,
    private readonly idle: Idle,
    private readonly keepalive: Keepalive,
    private readonly dialog: MatDialog) {
    this.router.events
    .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
    .subscribe((e : RouterEvent) => {
      this.navigationInterceptor(e);
    });

    // Set idle settings: 29 mins idle, 1 min timeout
    this.idle.setIdle(1740);
    this.idle.setTimeout(60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onTimeout.subscribe(() => {
      if (this.authService.isAuthenticated()) {
        this.authService.logout();
        localStorage.setItem('forceLogout', Date.now().toString()); 
        this.showSessionDialog();
      }
    });

    // Keepalive ping every 15 seconds
    this.keepalive.interval(15);

    window.addEventListener('storage', this.handleStorageEvent.bind(this));

    // Watch DOM activity globally to broadcast it
    ['mousemove', 'keydown', 'click'].forEach(evt => {
      window.addEventListener(evt, () => {
        localStorage.setItem('lastActivity', Date.now().toString());
        this.reset();
      });
    });

    
  }

  ngOnInit() {
    this.authService.getAppContent();
    this.reset();
  }

  browserRefresh: boolean = false;
  
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
        this.loaderService.show();
        this.browserRefresh = !this.router.navigated;
        if (this.browserRefresh && event.url === '/verification') {
          this.router.navigate(['login']);
          sessionStorage.removeItem('userInfo');
        }
    }
    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
      setTimeout(() => {
        this.loaderService.hide();
      }, 2000);
    }
  }

  reset() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    }
  }

  showSessionDialog(): void {
    this.dialogRef = this.dialog.open(this.sessionDialog, { disableClose: true, restoreFocus: false, panelClass: 'session-expire-dialog' });
  }

  handleStorageEvent(event: StorageEvent) {
    if (event.key === 'lastActivity') {
      // Reset idle in current tab if other tab was active
      this.reset();
    }

    if (event.key === 'forceLogout') {
      // Trigger logout in current tab
      if (this.authService.isAuthenticated()) {
        this.authService.logout();
        this.dialog.closeAll();
        this.showSessionDialog(); // Inform user
      }
    }
  }
}
